export default "__VITE_ASSET__9eda304d__"